import React from 'react';
import { motion } from 'framer-motion';
export function PrivateMasterclasses() {
  const customEase = [0.16, 1, 0.3, 1];
  return <section id="private" className="py-24 md:py-32 bg-cream relative texture-grain" data-id="element-307">
      <div className="w-full max-w-[100rem] mx-auto" data-id="element-308">
        <div className="flex flex-col lg:flex-row items-center" data-id="element-309">
          {/* Left Image Placeholder (60% width on desktop) */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 1.2,
          ease: customEase
        }} className="w-full lg:w-[60%] h-[50vh] lg:h-[80vh] bg-cream-dark relative flex items-center justify-center overflow-hidden rounded-sm" data-id="element-310">
            <img src="https://images.unsplash.com/photo-1560066984-138dadb4c035?w=800&q=80" alt="Private Masterclass Group" className="w-full h-full object-cover img-editorial" data-id="element-311" />
            <div className="warm-overlay" data-id="element-312"></div>
            <svg className="absolute w-full h-full text-cream opacity-20 z-20 pointer-events-none" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-313">
              <path d="M0 50 Q 50 0 100 50 T 200 50" fill="none" stroke="currentColor" strokeWidth="0.5" data-id="element-314" />
            </svg>
          </motion.div>

          {/* Right Content Panel (Overlapping) */}
          <motion.div initial={{
          opacity: 0,
          x: 40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          delay: 0.2,
          ease: customEase
        }} className="w-full lg:w-[45%] bg-white p-10 md:p-16 lg:p-20 relative z-10 lg:-ml-[5%] mt-[-10%] lg:mt-0 shadow-2xl shadow-ink/5" data-id="element-315">
            <p className="font-sans text-xs uppercase tracking-[0.3em] text-copper mb-6" data-id="element-316">
              Bespoke Experience
            </p>
            <h2 className="font-serif text-5xl md:text-6xl font-light text-ink mb-8 leading-tight" data-id="element-317">
              Private Masterclasses
            </h2>

            <p className="font-sans text-stone text-lg leading-relaxed mb-8" data-id="element-318">
              Create a bespoke makeup learning experience tailored to you and
              your group. Perfect for hens parties, birthdays, team experiences,
              or intimate one-to-one training.
            </p>

            <div className="space-y-4 mb-12" data-id="element-319">
              <p className="font-sans text-stone flex items-start gap-3" data-id="element-320">
                <span className="text-copper" data-id="element-321">—</span> Tailored curriculum for
                your group's needs
              </p>
              <p className="font-sans text-stone flex items-start gap-3" data-id="element-322">
                <span className="text-copper" data-id="element-323">—</span> Flexible scheduling and
                location options
              </p>
              <p className="font-sans text-stone flex items-start gap-3" data-id="element-324">
                <span className="text-copper" data-id="element-325">—</span> Premium, personalised
                attention
              </p>
              <p className="font-sans text-stone flex items-start gap-3" data-id="element-326">
                <span className="text-copper" data-id="element-327">—</span> Perfect for groups of
                4-12 or one-to-one
              </p>
            </div>

            <p className="font-sans text-stone text-sm mb-8" data-id="element-328">
              From $120 per person for groups of 4 or more.
            </p>

            <a href="#contact-form" className="inline-block text-xs uppercase tracking-[0.2em] text-ink hover:text-copper transition-colors border-b border-ink hover:border-copper pb-1" data-id="element-329">
              Enquire Now &rarr;
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}